import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { 
    Modal, ModalHeader, ModalBody, ModalFooter,
    Label, Input, Button, Table, Alert,
    Form, FormFeedback
} from "reactstrap";

import Dropzone from "react-dropzone";
import Dragula from 'react-dragula';
import { v4 as uuidv4 } from 'uuid';

import { useFormik } from "formik";

import { addPart } from "../../slices/thunks";
import { categories } from "../../common/data/olxCategories";
import {partInitValues, partValidationSchema } from "../../models/part";
import { allAttributes } from "../../common/data/requiredAttributes";
import { yearsSpanAscending, yearsSpanDescending } from "../../common/data/allYearLists";

const PartModal = ({show, onCloseClick}) => {
    const dispatch = useDispatch();

    const user = JSON.parse(sessionStorage.getItem("authUser"));
    const isAdmin = user.role == 'Admin' ? true : false;
    
    const[isBatchMode, setIsBatchMode] = useState(false);
    const [files, setFiles] = useState([]);

    const[attributes, setAttributes] = useState([]);
    const handleSelectAttribute = (event, attribute) => {
        let newAttribute = {
            id: uuidv4(),
            olxId: attribute.olxId,
            parentOlxId: attribute.parentOlxId,
            value: attribute.options != null ? attribute.options[event.target.value].value : event.target.value,
            label: attribute.options != null ? attribute.options[event.target.value].label : event.target.value
        };
        if(!attributes.length){
            attributes.push(newAttribute);
            setAttributes(attributes);
        }
        else{
            let updatedAttrs = attributes.map(item => (item.olxId == newAttribute.olxId && item.parentOlxId == newAttribute.parentOlxId) ? {...item, ...newAttribute} : item);
            let existingAttr = attributes.find(item => item.olxId == newAttribute.olxId && item.parentOlxId == newAttribute.parentOlxId);
            if(!existingAttr) updatedAttrs.push(newAttribute);
            setAttributes(updatedAttrs)
        }        
    }
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: partInitValues,
        validationSchema: partValidationSchema,
        onSubmit: (values) => {                       
            let images = [];
            for(var i = 0; i < rows.length; i++){
                let file = files.find(f => f.id == rows[i].id);
                file.index = i + 1;
                images.push(file);
            }
            let part = {
                name: values.name,
                catalogNumber: values.catalogNumber || "BB",
                location: values.location || null,
                position: values.position || null,
                originVehicle: values.originVehicle || null,
                color: values.color || null,
                yearStart: values.yearStart,
                yearEnd: values.yearEnd,
                categoryId: values.category,
                description: values.description,
                attributes: attributes.filter(item => item.parentOlxId == values.category).map(attr => ({id: attr.id, parentOlxId: attr.parentOlxId, olxId: attr.olxId, option: attr.label})),
                status: isAdmin ? 1 : 2,
                sellingPrice: isAdmin ? values.sellingPrice : null, 
                images: images
            };
            dispatch(addPart(part));
            handleOnCloseClick();
        },
    });

    const handleFormSubmit = (e) => {
        e.preventDefault();
        validation.handleSubmit();
        return false;
    };

    const handleOnCloseClick = () => {
        if(!isBatchMode){
            validation.resetForm();
            setAttributes([]);
        }
        setFiles([]);
        onCloseClick();
    };
    
    function handleAcceptedFiles(uploadedFiles) {  
        let i = files.length; 
        uploadedFiles.map(file => {
            i++;
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                id: uuidv4(),
                index: i
            })
        });
        setFiles([...files, ...uploadedFiles]);
    }
    const deleteFile = (file) => {
        const modifiedFileList = files.filter(item => item.id != file.id);
        let i = 0;
        modifiedFileList.forEach(item => {
            i++;
            item.index = i;
        })
        setFiles(modifiedFileList);
    }

    var container = document.getElementById("image-container");
    var rows = !container ? [] : container.children || [];
    var nodeListForEach = function (array, callback, scope) {
        for (var i = 0; i < array.length; i++) {
            callback.call(scope, i, array[i]);
        }
    };
    
    var sortableTable = Dragula([container]);
        sortableTable.on('dragend', function() {
        nodeListForEach(rows, function (index, row) {
            row.dataset.rowPosition = index + 1;
        });
    });

    return(
        <Modal id="partModal" isOpen={show} toggle={handleOnCloseClick} centered backdrop={'static'}>
            <ModalHeader className="modal-title" toggle={handleOnCloseClick}>Dodaj novi dio</ModalHeader>
            <Form className="tablelist-form" onSubmit={handleFormSubmit}>
            <ModalBody>
                <div className="row m-3">
                    <div className="form-check form-switch">                        
                        <Input name="batchMode" className="form-check-input" type="switch" checked={isBatchMode} onChange={() => {setIsBatchMode(!isBatchMode)}}/>
                        <Label className="form-check-label">Sačuvaj podatke za sljedeći unos?</Label>
                    </div>
                </div>
                {/* Naziv dijela, Kataloski broj */}
                <div className="row gy-4 mb-3">
                    <div className="col-md-8">
                        <Input name="name" type="text" className="form-control"
                            placeholder="Naziv dijela"                              
                            validate={{ required: { value: true }}}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.name || ""}
                            invalid={validation.touched.name && validation.errors.name ? true : false}
                        /> {validation.touched.name && validation.errors.name ?(<FormFeedback type="invalid">{validation.errors.name}</FormFeedback>) : null}
                    </div>
                    <div className="col-md-4">
                        <Input name="catalogNumber" type="text" className="form-control"
                            placeholder="Kataloški broj"                              
                            validate={{required: { value: false }}}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.catalogNumber || ""}
                            invalid={validation.touched.catalogNumber && validation.errors.catalogNumber ? true : false}
                        /> {validation.touched.catalogNumber && validation.errors.catalogNumber ? (<FormFeedback type="invalid">{validation.errors.catalogNumber}</FormFeedback>) : null}
                    </div>                       
                </div>
                {/*Lokacija dijela, Broj sasije vozila na kojem je dio, */}
                <div className="row gy-4 mb-3">
                    <div className="col-md-8">                      
                        <Input name="originVehicle" type="text" className="form-control"
                            placeholder="Broj šasije vozila"
                            validate={{required: { value: false }}}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.originVehicle || ""}
                            invalid={validation.touched.originVehicle && validation.errors.originVehicle ? true : false}
                        />{validation.touched.originVehicle && validation.errors.originVehicle ? (<FormFeedback type="invalid">{validation.errors.originVehicle}</FormFeedback>) : null}                      
                    </div>
                    <div className="col-md-4">
                        <Input name="location" type="text" className="form-control"
                            placeholder="Lokacija"                          
                            validate={{required: { value: true }}}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.location || ""}
                            invalid={validation.touched.location && validation.errors.location ? true : false}
                        />{validation.touched.location && validation.errors.location ? (<FormFeedback type="invalid">{validation.errors.location}</FormFeedback>) : null}
                    </div>
                </div>
                {/*Boja, Strana*/}
                <div className="row gy-4 mb-3">
                    <div className="col-6">
                        <Input name="color" type="text" className="form-control"
                            placeholder="Boja"                          
                            validate={{required: { value: false }}}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.color || ""}
                            invalid={validation.touched.color && validation.errors.color ? true : false}
                        />{validation.touched.color && validation.errors.color ? (<FormFeedback type="invalid">{validation.errors.color}</FormFeedback>) : null}
                    </div>
                    <div className="col-6">
                        <Input name="position" type="text" className="form-control"
                            placeholder="Strana"                          
                            validate={{required: { value: false }}}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.position || ""}
                            invalid={validation.touched.position && validation.errors.position ? true : false}
                        />{validation.touched.position && validation.errors.position ? (<FormFeedback type="invalid">{validation.errors.position}</FormFeedback>) : null}
                    </div>
                </div>
                {/*Godiste rasponi*/}
                <div className="row gy-4 mb-3">
                    <div className="col-md-6">
                        <Input name="yearStart" type="select" className="form-select"                           
                            validate={{required: { value: false }}}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.yearStart || ""}
                            invalid={validation.touched.yearStart && validation.errors.yearStart ? true : false}
                        >
                            {yearsSpanAscending.map(item => (<option value={item.value} key={item.value}>{item.label}</option>))}
                        </Input>
                        {validation.touched.yearStart && validation.errors.yearStart ? (<FormFeedback type="invalid">{validation.errors.yearStart}</FormFeedback>) : null}
                    </div>
                    <div className="col-md-6">
                        <Input name="yearEnd" type="select" className="form-select"                         
                            validate={{ required: { value: false }}}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.yearEnd || ""}
                            invalid={ validation.touched.yearEnd && validation.errors.yearEnd ? true : false }
                        >
                            {yearsSpanDescending.map(item => (<option value={item.value} key={item.value}>{item.label}</option>))}
                        </Input>
                        {validation.touched.yearEnd && validation.errors.yearEnd ? (<FormFeedback type="invalid">{validation.errors.yearEnd}</FormFeedback>) : null}
                    </div>
                </div>
                {/* Olx kategorija dijela */}
                <div className="row gy-4 mb-3">
                    <div className="col-md-8 mx-auto">
                    <Input name="category" type="select" className="form-select"                           
                        validate={{required: { value: true }}}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.category || ""}
                        invalid={validation.touched.category && validation.errors.category ? true : false}
                        >
                            {categories.map(item => (<option value={item.value} key={item.value}>{item.label}</option>))}
                        </Input>
                        {validation.touched.category && validation.errors.category ? (<FormFeedback type="invalid">{validation.errors.category}</FormFeedback>) : null}
                    </div>                    
                </div>
                <div className="row gy-4 mb-3">
                    {allAttributes.filter(item => item.parentOlxId == validation.values.category)
                        .map(item => (
                        <div className="col-md-6 mx-auto" key={item.olxId}>
                        {item.inputType == "number" ? (
                            <Input name={item.name} type="number" className="form-control"
                                placeholder= {item.olxId === 5078 ? "Jačina (Ah)" : "Jačina (W)"}
                                value={attributes.find(attr => attr.olxId == item.olxId)?.value ?? ""}
                                onChange={(e) => {handleSelectAttribute(e, item)}}
                            />
                        ):(
                            <Input name={item.name} type="select" className="form-select"
                                value={attributes.find(attr => attr.olxId == item.olxId)?.value ?? 0}
                                onChange={(e) => {handleSelectAttribute(e, item)}}
                            >
                                {item.options.map(opt => (<option value={opt.value} key={opt.value}>{opt.label}</option>))}
                            </Input>)}
                        </div>
                    ))}
                </div>
                {/* Status dijela, Cijena dijela */}
                {!isAdmin ? null : (
                    <div className="row gy-4 mb-3">
                        <div className="col-md-6 input-group">                      
                            <Input name="sellingPrice" type="number" className="form-control"
                                placeholder="Cijena"                      
                                validate={{required: { value: isAdmin }}}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.sellingPrice}
                                invalid={validation.touched.sellingPrice && validation.errors.sellingPrice ? true : false}
                            />
                            <div className="input-group-text">BAM</div>
                            {validation.touched.sellingPrice && validation.errors.sellingPrice ? (<FormFeedback type="invalid">{validation.errors.sellingPrice}</FormFeedback>) : null}
                        </div>
                    </div>
                )}
                <div className="mb-3">
                    <Input name="description" type="textarea" className="form-control"
                        placeholder="Opis"                      
                        validate={{required: { value: false }}}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.description}
                        invalid={validation.touched.description && validation.errors.description ? true : false}
                    />
                </div>
                {!(files.length > 0) && (<Alert color="danger" className="text-center fs-20">Morate dodati bar jednu sliku!</Alert>)}
                {files.length > 10 && (<Alert color="danger" className="text-center fs-20">Dodali ste {files.length} slika, što je više od 10 slika.</Alert>)}
                <div>
                <Dropzone onDrop={acceptedFiles => {handleAcceptedFiles(acceptedFiles)}}>
                {({ getRootProps, getInputProps }) => (
                  <div className="dropzone dz-clickable" {...getRootProps()}>
                  <input {...getInputProps()} />
                    <div className="dz-message needsclick">
                      <i className="display-5 text-muted ri-upload-cloud-2-fill" />
                      <p>Drop files here or click to upload.</p>
                    </div>
                  </div>
                )}
              </Dropzone>
              <div className="list-unstyled mb-0" id="file-previews" >
                <div className="table-responsive mb-1">
                  <Table className="align-middle table table-borderless">                        
                    <tbody id="image-container">
                      {files.map(f => {
                        return (
                          <tr id={f.id} key={f.id} className="dz-processing dz-image-preview dz-success dz-complete">                                
                            <td>
                              <img src={f.preview} alt={f.name} className="avatar-md rounded me-2" data-dz-thumbnail=""/>
                              <span className="text-muted fw-bold">{f.name + " (" + f.formattedSize + ")"}</span>
                            </td>
                            <td>
                              <button className="btn btn-sm btn-soft-danger remove-list" onClick={() => deleteFile(f)}>
                                <i className="ri-delete-bin-5-fill align-bottom"/>
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                </tbody>
                </Table>
              </div> 
              </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <div className="hstack gap-2 justify-content-end">
                    <Button color="dark" outline onClick={() => {handleOnCloseClick()}}> Zatvori </Button>
                    {(files.length > 0 && files.length < 11) && (<Button color="success" outline type="submit">Dodaj novi dio</Button>)}
                </div>
            </ModalFooter>
            </Form>
        </Modal>
    );
};

export default PartModal;